import { createOAuthConfiguration } from '@consigli/oauth';
import { notNull } from '@consigli/utils';
import { oneOf } from '@consigli/utils';
export var ViteMode;
(function (ViteMode) {
    ViteMode["TEST"] = "test";
    ViteMode["LOCAL_DEV"] = "local-dev";
    ViteMode["DEV"] = "dev";
    ViteMode["PROD"] = "prod";
    ViteMode["TEST_ENV"] = "test-env";
    ViteMode["SANDBOX"] = "sandbox";
    ViteMode["PDE"] = "pde";
    // The GCP replication of the estate (gcp-poc.ai4eng.aecom.team). config.MODE
    // is validated against this enum at import, so a mode missing from here
    // throws before React mounts and the page renders blank.
    ViteMode["GCP_POC"] = "gcp-poc";
})(ViteMode || (ViteMode = {}));
export const config = {
    MODE: oneOf(notNull(import.meta.env.MODE, 'meta.env.MODE'), Object.values(ViteMode)),
    OAUTH_ENDPOINT: notNull(import.meta.env.VITE_OAUTH_ENDPOINT, 'meta.env.VITE_OAUTH_ENDPOINT'),
    DEV: notNull(import.meta.env.DEV, 'meta.env.DEV'),
    PROD: notNull(import.meta.env.PROD, 'meta.env.PROD'),
    CORE_API_BASE_URL: notNull(import.meta.env.VITE_CORE_API_BASE_URL, 'meta.env.VITE_CORE_API_BASE_URL'),
    CHAT_API_BASE_URL: notNull(import.meta.env.VITE_CHAT_API_BASE_URL, 'meta.env.VITE_CHAT_API_BASE_URL'),
    MEETING_API_BASE_URL: notNull(import.meta.env.VITE_MEETING_API_BASE_URL, 'meta.env.VITE_MEETING_API_BASE_URL'),
    BUILDING_AGENT_BASE_URL: notNull(import.meta.env.VITE_BUILDING_AGENT_BASE_URL, 'meta.env.VITE_BUILDING_AGENT_BASE_URL'),
    WEBAPP_URL: notNull(import.meta.env.VITE_WEBAPP_URL, 'meta.env.VITE_WEBAPP_URL'),
    WEBAPP_CLIENT_ID: notNull(import.meta.env.VITE_WEBAPP_CLIENT_ID, 'meta.env.VITE_WEBAPP_CLIENT_ID'),
};
export const authConfig = createOAuthConfiguration({
    webappClientId: config.WEBAPP_CLIENT_ID,
    webappUrl: config.WEBAPP_URL,
    oauthEndpoint: config.OAUTH_ENDPOINT,
});
